<ng-container *ngIf="badge as BadgeConfig">
  <core-badge
    [color]="badge.textColor"
    [backgroundcolor]="badge.backgroundColor"
    [label]="showLabel ? badge.label : ''"
    tabindexvalue="0"
    [showicon]="!!badge.icon"
  >
    <mat-icon *ngIf="badge.icon" [svgIcon]="badge.icon" slot="icon" [style.color]="badge.iconColor">
    </mat-icon>
  </core-badge>
</ng-container>
